import axios from "axios";
import moment from "moment";
import { ACCESS_TOKEN, API_URL, REFRESH_TOKEN } from "../constants";
import Cookie from "./cookie";

let isRefreshing = false;
let failedQueue = [];
let call = {};

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const axiosApiInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "x-timezone-offset": moment().format("Z"),
    post: {
      "Content-Type": "application/json",
    },
  },
});

axiosApiInstance.interceptors.request.use(
  (config) => {
    const accessToken = Cookie.get(ACCESS_TOKEN);
    if (accessToken) {
      config.headers.common["Authorization"] = `Bearer ${accessToken}`;
      config.headers.common["isLogin"] = true;

      //cancel duplicate GET requests
      if (
        config.method === "get" &&
        config.method === call.method &&
        JSON.stringify(config.params) === JSON.stringify(call.params) &&
        config.url === call.url &&
        Date.now() - call.timestamp < 2000
      ) {
        return {
          ...config,
          cancelToken: new axios.CancelToken((cancel) =>
            cancel("Cancel repeated request")
          ),
        };
      } else {
        call = {
          url: config.url,
          method: config.method,
          params: config.params,
          timestamp: Date.now(),
        };
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!error.response) return false;
    const { status, config } = error.response;

    switch (status) {
      case 401:
        if (!config._retry) {
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            })
              .then((token) => {
                config.headers["Authorization"] = "Bearer " + token;
                return axios(config);
              })
              .catch((err) => {
                return Promise.reject(err);
              });
          }

          config._retry = true;
          isRefreshing = true;

          const refreshToken = Cookie.get(REFRESH_TOKEN);

          return new Promise((resolve, reject) => {
            axiosApiInstance
              .post("/auth/refresh-token", {
                refreshToken,
              })
              .then(({ data }) => {
                Cookie.set(ACCESS_TOKEN, data.accessToken, {
                  expires: 2,
                });
                Cookie.set(REFRESH_TOKEN, data.refreshToken);
                axiosApiInstance.defaults.headers.common["Authorization"] =
                  "Bearer " + data.accessToken;
                config.headers["Authorization"] = "Bearer " + data.accessToken;
                processQueue(null, data.accessToken);
                resolve(axios(config));
              })
              .catch((err) => {
                const { status: refreshStatus } = err.response;
                if (refreshStatus === 400) {
                  Cookie.remove(ACCESS_TOKEN);
                  Cookie.remove(REFRESH_TOKEN);
                  window.location.href = `/?redirect=${btoa(
                    window.location.pathname + window.location.search
                  )}`;
                  return;
                }
                processQueue(err, null);
                reject(err);
              })
              .finally(() => {
                isRefreshing = false;
              });
          });
        }
        break;
      case 404:
      case 403:
        if (!config.url.includes("login")) {
          // window.location.href = "/404";
        }
        break;
      default:
        break;
    }

    return Promise.reject(error);
  }
);

export default axiosApiInstance;
